import React from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getRemoteStream } from '../../callback';
import { startCallingTimer } from '../../Helpers/Call/Call';
import { handleParticipantList } from '../../Helpers/Chat/ChatHelper';
import { handleSplitUserId } from '../../Helpers/Chat/RecentChat';
import { getLocalUserDetails } from '../../Helpers/Chat/User';
import { getFromLocalStorageAndDecrypt } from '../../Helpers/Chat/webChatEncryptDecrypt';
import { showModal } from '../../Redux/feature/popUpDataSlice';
import { addShowConfrenceData } from '../../Redux/feature/showConfrenceDataSlice';
import { store } from '../../Redux/store';
import SDK from '../../SDK';
import callLogs from './CallLogs/callLog';

const InviteParticipants = (props = {}) =>{
    let callConnectionData = {};
    let currentCallUsers = [];
    let groupId = '';
    const storeData = useSelector((state) => state);
    const vCardData = getLocalUserDetails()
    const rosterData = useSelector(state => state.rosterData)
    const   { data: totalContactList = [] } = rosterData
    const { 
        groupsMemberParticipantsListData :{ groupParticipants = {} } ,
        groupsData = {}
    } = storeData
    
    React.useEffect(()=>{
        props.invite && openInvitePopup();
    },[])

    const getGroupMembers = (participants) => {
        return participants && (handleParticipantList(participants, totalContactList) || [])
    }

    const openInvitePopup = async() => {
        if(!props.invite){
            return;
        }
        callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt('call_connection_status'));
        currentCallUsers = [];
        let currentCallUsersArray = [];
        groupId = '';
        let groupName = null;
        let groupDetails = null;
        const callMode = callConnectionData.callMode;
        let groupMemberDetails = [];
        let emptyMembersMsg = '';
        currentCallUsers = props.remoteStream.filter((user) => {
            let id = handleSplitUserId(user.fromJid);
            if(vCardData?.fromUser !== id){
                return id;
            }
        });
        currentCallUsersArray = props.remoteStream.map((user) => handleSplitUserId(user.fromJid));        

        if(callMode === 'onetomany' && callConnectionData.groupId && callConnectionData.groupId !== null && callConnectionData.groupId !== ""){
            emptyMembersMsg = 'All members of the group are already in the call.'
            groupId = callConnectionData.groupId || callConnectionData.to;
            const participants = groupParticipants[groupId];
            if(participants && participants.length > 0){
                groupMemberDetails = getGroupMembers(participants);
            }
            groupDetails = getGroupDetails(groupId.includes("@") ? groupId.split('@')[0] : groupId);
            groupName = groupDetails.displayName;            
        }
        else{
            groupMemberDetails = totalContactList;
            emptyMembersMsg = 'All the users of your contacts already in call.'
        }

        let groupMembers = [];
        let requiredGroupMemberDetails = [];
        if(groupMemberDetails !== null){
            groupMemberDetails.map( member => {
                let rosterDataGroup = {};
                let user = member.userJid || member.GroupUser || member.username;
                const userId = user.includes("@") ? user.split('@')[0] : user;
                if(userId !== vCardData?.fromUser  && currentCallUsersArray.indexOf(userId) === -1 && (member.isFriend || groupId)){
                    rosterDataGroup = {
                        userJid: user
                    }
                    groupMembers.push(user);
                    requiredGroupMemberDetails.push(rosterDataGroup);
                }  
            });
        }
        const disableParticipantPopup = false;
        if(groupMembers.length === 0 && disableParticipantPopup){
            toast.info(emptyMembersMsg)
            return;
        }
        store.dispatch(showModal({
            open:true,
            modelType:'inviteParticipants',
            groupName: groupName,
            groupMembers: groupMembers,
            groupuniqueId: groupId,
            groupMemberDetails: requiredGroupMemberDetails,
            makeGroupCall: invite,
            callType:callConnectionData.callType,
            currentCallUsersLength: currentCallUsers.length,
            closePopup: props.closePopup,
            currentCallUsers: currentCallUsersArray
        }))
    }

    const getGroupDetails = (group_Id) => {
        let rosterDataDetail = {};
        let groupList = groupsData?.data;
        groupList.map((group) => {
            let groupJid = group.groupId;
            if(groupJid === group_Id){
                rosterDataDetail.displayName = group.groupName;
                rosterDataDetail.image = group.groupImage;
                rosterDataDetail.jid = groupJid;
                rosterDataDetail.chatType = "groupchat";
                return rosterDataDetail;
            }
            return false;     
        })
        return rosterDataDetail;
    }


    const invite = async (callType, inviteCallMemberDetails) => {
        let connectionStatus = getFromLocalStorageAndDecrypt("connection_status")
        if(connectionStatus === "CONNECTED"){
            const users = inviteCallMemberDetails;
            if(users.length > 0){
                let call = await SDK.inviteUsers(users)
                if(call.statusCode === 200) {
                    const showConfrenceData = store.getState().showConfrenceData;
                    const { data } = showConfrenceData;
                    store.dispatch(addShowConfrenceData({
                        ...(data || {}),
                        status: "REMOTESTREAM",
                        remoteStream: getRemoteStream()
                    }));
                    startCallingTimer();
                    callLogs.update(callConnectionData.roomId, {
                        "userList": users.join(',')
                    });
                } else {
                    toast.error(call.message);
                }
            }
        }
    }

    return null;
    
}

export default InviteParticipants;